import { cssVarColors } from 'lib/cssSelector'
import { Styles } from 'react-jss'
const { contentBg } = cssVarColors

export const sheet: Styles = {
  columnBlock: {},
  content: {
    backgroundColor: contentBg,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    height: '80vh',
    width: '1300px',
    '@media (max-width: 1400px)': {
      width: '100%'
    },
    '@media (max-width: 800px)': {
      flexDirection: 'column'
    }
  },
  logoFlexWrapper: {
    flex: 1.2,
    '@media (max-width: 800px)': {
      '& > $logoWrapper': {
        padding: 60
      }
    }
  },
  logoWrapper: {
    flex: 1,
    zIndex: 1,
    position: 'relative',
    padding: 20,
    gap: '20px'
  },
  logo: {
    maxHeight: '120px'
  },
  formTitle: {
    gap: '20px',
    paddingBottom: '60px'
  },
  formInner: {
    gap: '30px'
  },

  forgotPasswordContainer: {
    position: 'relative'
  },
  forgotPassword: {
    position: 'absolute',
    top: 0,
    right: 0
  },

  form: {
    boxSizing: 'border-box',
    boxShadow: ' -28px 0px 50.49px 0px #0000000D',
    alignItems: 'center',
    padding: '20px clamp(10px, 5vw, 80px)',
    position: 'relative',
    flex: 0.7,
    backgroundColor: '#FFFFFF',
    '@media (max-width: 800px)': {
      width: 'auto'
    }
  },
  buttonGroup: {
    paddingTop: '10px',
    gap: '20px'
  },
  '@media (min-width: 992px) and (max-width: 1199.98px)': {
    form: {
      '& > h4': {
        whiteSpace: 'nowrap'
      }
    }
  },
  '@media (min-width: 600px) and (max-width: 991.98px)': {
    form: {},
    inputRow: {
      margin: '1.5em 0'
    },
    buttonGroup: {}
  }
}
